export default __webpack_public_path__ + "static/media/burst-sm-2.70f8194a.mp3";